import React, { useEffect, useState } from 'react';
import VideoContainer from './VideoContainer';
import { usePlayerStore, getStore } from '../../../stores/StoreContext';
import { useSecondPaneContext } from '../../Common/SplitView/SplitViewContext';
const Focused = () => {
  const SessionTracks = usePlayerStore((state) => state.tracks);
  const focusedTrackId = usePlayerStore((state) => state.focusedTrackId);
  const { width, height } = useSecondPaneContext();
  const [trackStatus, setTrackStatus] = useState(false);
  
  const currentTime = usePlayerStore((state) => state.currentTime);
  const PlayerStore = getStore('playerStore');
  
  useEffect(() => {
    setTrackStatus(PlayerStore.getTrackStatusAtTime(SessionTracks[focusedTrackId], currentTime));
  }, [currentTime, focusedTrackId]);

  // Auto-focus a track if none is focused but tracks are available
  useEffect(() => {
    if (!focusedTrackId && Object.keys(SessionTracks).length > 0) {
      PlayerStore.autoSetFocusedTrack(true);
    }
  }, [focusedTrackId, SessionTracks, PlayerStore]);

  return (
    <>
      {focusedTrackId && (
        <VideoContainer
          isFocusedTrack={true}
          SessionTrack={SessionTracks[focusedTrackId]}
          width={width}
          height={height}
          trackStatus={trackStatus}
        />
      )}
    </>
  );
};

export default Focused;
